import React from "react";

export function WhatsAppIcon({ size = 20, color = "currentColor", className = "", ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={size}
            height={size}
            className={className}
            aria-hidden
            {...props}
        >
            <path
                fill={color}
                d="M12.04 2C6.56 2 2.1 6.43 2.1 11.88c0 1.75.46 3.46 1.34 4.96L2 22l5.3-1.39a9.98 9.98 0 0 0 4.74 1.2h.01c5.48 0 9.94-4.43 9.94-9.88A9.9 9.9 0 0 0 12.04 2Zm0 18.13h-.01a8.28 8.28 0 0 1-4.22-1.15l-.3-.18-3.14.82.84-3.05-.2-.31a8.14 8.14 0 0 1-1.26-4.38c0-4.52 3.72-8.2 8.3-8.2a8.28 8.28 0 0 1 8.29 8.24c-.01 4.53-3.73 8.21-8.3 8.21Zm4.55-6.15c-.25-.12-1.48-.73-1.71-.81-.23-.08-.4-.12-.57.12-.17.25-.65.81-.8.98-.15.17-.29.19-.54.06-.25-.12-1.05-.38-2-1.22-.74-.66-1.24-1.47-1.39-1.72-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.15.17-.25.25-.42.08-.17.04-.31-.02-.43-.06-.12-.57-1.36-.78-1.87-.2-.49-.41-.42-.57-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.86.84-.86 2.04s.88 2.37 1 2.53c.12.17 1.73 2.62 4.2 3.68.59.25 1.04.4 1.4.51.59.19 1.12.16 1.55.1.47-.07 1.48-.6 1.69-1.18.21-.58.21-1.08.15-1.18-.06-.11-.23-.17-.48-.29Z"
            />
        </svg>
    );
}

export function SnapchatIcon({ size = 20, color = "currentColor", className = "", ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={size}
            height={size}
            className={className}
            aria-hidden
            {...props}
        >
            <path
                fill={color}
                d="M12 2.75c2.75 0 4.55 1.94 4.55 4.9v.54c0 .72-.04 1.39.08 1.73.12.35.5.48.91.6.36.11.74.22.83.58.13.53-.54.97-1.18 1.22-.29.12-.51.2-.58.37-.07.19.08.49.27.79.7 1.11 1.61 1.67 2.85 1.86.44.07.52.63.18.91-.46.38-1.06.59-1.69.65-.24.03-.35.12-.45.34-.19.42-.46.8-1.05.8-.25 0-.54-.06-.86-.13-.42-.09-.9-.2-1.46-.2-.75 0-1.33.31-1.96.65-.72.39-1.48.81-2.45.81s-1.73-.42-2.45-.81c-.63-.34-1.21-.65-1.96-.65-.56 0-1.04.11-1.46.2-.32.07-.61.13-.86.13-.59 0-.86-.38-1.05-.8-.1-.22-.21-.31-.45-.34-.63-.06-1.23-.27-1.69-.65-.34-.28-.26-.84.18-.91 1.24-.19 2.15-.75 2.85-1.86.19-.3.34-.6.27-.79-.07-.17-.29-.25-.58-.37-.64-.25-1.31-.69-1.18-1.22.09-.36.47-.47.83-.58.41-.12.79-.25.91-.6.12-.34.08-1.01.08-1.73v-.54c0-2.96 1.8-4.9 4.55-4.9Zm0 1.55c-1.85 0-2.96 1.26-2.96 3.35v.58c0 .94.04 1.71-.17 2.32-.25.72-.84 1.09-1.45 1.31.86.36 1.04 1.14.4 2.15-.47.75-1.03 1.32-1.69 1.73.96-.09 1.75.15 2.47.54.57.31 1.05.56 1.4.56s.83-.25 1.4-.56c.72-.39 1.51-.63 2.47-.54-.66-.41-1.22-.98-1.69-1.73-.64-1.01-.46-1.79.4-2.15-.61-.22-1.2-.59-1.45-1.31-.21-.61-.17-1.38-.17-2.32v-.58c0-2.09-1.11-3.35-2.96-3.35Z"
            />
        </svg>
    );
}
